import { AccountSettingTitle } from 'types/enums';
import { AccountSettingResponseDto } from 'types/types';

const getNotificationSettingMessage = ({ title }: AccountSettingResponseDto) => {
  switch (title) {
    case AccountSettingTitle.EMAIL:
      return 'Email notifications are enabled';
    case AccountSettingTitle.PUSH:
      return 'Push notifications are enabled';
    default:
      return '';
  }
};

export { getNotificationSettingMessage };
